export function isRunningNodeJs() {
	if (typeof window === 'undefined') {
		return true;
	}

	return (typeof module !== 'undefined' && module.exports !== undefined);
}
